import type { Common } from '../common.js';
import {
  type ModelLifecycleFindAllParams,
  type ModelLifecycleResponse,
} from '../models/flow/modelLifecycle.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/model-lifecycle';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(queryParams?: ModelLifecycleFindAllParams): Promise<ModelLifecycleResponse> {
    const url = this.common.constructPath(this.baseEndpoint, queryParams);
    return await this.common.getJSON(url);
  }
}
